'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var QueryTypeOptionService = function QueryTypeOptionService($http, $q, $rootScope, $sanitize, $location) {

    var queryTypeOptions = [];
    var queryCategoryOptions = [];
    var querySubjectOptions = [];
    var queryStatuses = [];
    var queryReasons = [];

    var categories = function categories() {
        var deferred = $q.defer();
        if (!queryCategoryOptions.Promise) {
            $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
            queryCategoryOptions = $http.get(WEBSERVICEURL + '/dataagility/api/service.querycategory').then(function successCallback(response) {
                var options = [];
                angular.forEach(response.data, function (value, key) {
                    var sterilizedName = $sanitize(value['name']);
                    if (sterilizedName) {
                        options.push({ id: value['queryCategoryId'], value: sterilizedName });
                    }
                });
                queryCategoryOptions = options;
                deferred.resolve(options);
            }, function errorCallback(response) {
                if (response.status === 401) {
                    window.location.replace(window.location.origin + '/login?logout=true');
                }
            });
        } else {
            deferred.resolve(queryCategoryOptions);
        }
        return deferred.promise;
    };

    var reasons = function reasons() {
        var deferred = $q.defer();
        if (!queryReasons.Promise) {
            $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
            queryReasons = $http.get(WEBSERVICEURL + '/dataagility/api/service.queryreason').then(function successCallback(response) {
                var options = [];
                angular.forEach(response.data, function (value, key) {
                    var sterilizedName = $sanitize(value['name']);
                    if (sterilizedName) {
                        options.push({ id: value['queryReasonId'], value: sterilizedName });
                    }
                });
                queryReasons = options;
                deferred.resolve(options);
            }, function errorCallback(response) {
                if (response.status === 401) {
                    window.location.replace(window.location.origin + '/login?logout=true');
                }
            });
        } else {
            deferred.resolve(queryReasons);
        }
        return deferred.promise;
    };

    var types = function types(queryAuditTypeTableUrl) {
        var deferred = $q.defer();
        if (!queryTypeOptions.Promise && !queryTypeOptions.length) {
            $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
            queryTypeOptions = $http.get(WEBSERVICEURL + '/dataagility/api/service.' + queryAuditTypeTableUrl) // wchn: queryaudittype/base, alfred endpoint: drgaudittype
            .then(function successCallback(response) {
                var options = [];
                angular.forEach(response.data, function (value, key) {
                    var sterilizedName = $sanitize(value['name']);
                    if (sterilizedName) {
                        options.push({ name: sterilizedName, id: value['queryAuditTypeId'] });
                    }
                });
                queryTypeOptions = options;
                deferred.resolve(options);
            }, function errorCallback(response) {
                if (response.status === 401) {
                    window.location.replace(window.location.origin + '/login?logout=true');
                }
            });
        } else {
            deferred.resolve(queryTypeOptions);
        }
        return deferred.promise;
    };

    var subjects = function subjects() {
        var deferred = $q.defer();
        if (!querySubjectOptions.Promise) {
            $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
            querySubjectOptions = $http.get(WEBSERVICEURL + '/dataagility/api/service.querysubject').then(function successCallback(response) {
                var options = [];
                angular.forEach(response.data, function (value, key) {
                    var sterilizedName = $sanitize(value['name']);
                    if (sterilizedName && options.indexOf(sterilizedName) === -1) {
                        options.push(sterilizedName);
                    }
                });
                querySubjectOptions = options;
                deferred.resolve(options);
            }, function errorCallback(response) {
                if (response.status === 401) {
                    window.location.replace(window.location.origin + '/login?logout=true');
                }
            });
        } else {
            deferred.resolve(querySubjectOptions);
        }
        return deferred.promise;
    };

    var statuses = function statuses() {
        var deferred = $q.defer();
        if (!queryStatuses.Promise) {
            $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
            queryStatuses = $http.get(WEBSERVICEURL + '/dataagility/api/service.querystatus').then(function successCallback(response) {
                var options = [];
                angular.forEach(response.data, function (value, key) {
                    var sterilizedName = $sanitize(value['name']);
                    if (sterilizedName && value['isActive']) {
                        options.push({ name: sterilizedName, id: value['queryStatusId'] });
                    }
                });
                queryStatuses = options;
                deferred.resolve(options);
            }, function errorCallback(response) {
                if (response.status === 401) {
                    window.location.replace(window.location.origin + '/login?logout=true');
                }
            });
        } else {
            deferred.resolve(queryStatuses);
        }
        return deferred.promise;
    };

    return { types: types, categories: categories, subjects: subjects, statuses: statuses, reasons: reasons };
};

exports.default = QueryTypeOptionService;


// WEBPACK FOOTER //
// ./client/app/common/services/queryModalOption.service.js